import {ActivatedRouteSnapshot, CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {OffersSelectors} from '../store/selectors';
import {OffersActions} from '../store';

@Injectable()
export class CurrentOfferLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    const iri = route.params.iri;

    return this.currentOfferLoaded(iri).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  currentOfferLoaded(iri: string): Observable<boolean | any> {
    return this.store.pipe(
      select(OffersSelectors.selectCurrentOffer),
      tap(invoice => {
        if (!invoice) {
          this.store.dispatch(OffersActions.ReadOffer({iri}));
        }
      }),
      filter(invoice => !!invoice),
      take(2)
    );
  }
}
